import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import crypto from 'crypto-js'
import { isUnauthorized, redirectToLogin } from './authRedirect'
// import { Loading } from 'element-ui';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000000 // request timeout
})
let loadingInstance = null

function replaceNewlineWithBr(payload) {
  if (typeof FormData !== 'undefined' && payload instanceof FormData) {
    return payload
  }
  if (typeof payload === 'string') {
    return payload.replace(/\r\n|\r|\n/g, '<br>')
  }
  if (Array.isArray(payload)) {
    return payload.map(item => replaceNewlineWithBr(item))
  }
  if (payload && typeof payload === 'object') {
    const next = {}
    Object.keys(payload).forEach(key => {
      next[key] = replaceNewlineWithBr(payload[key])
    })
    return next
  }
  return payload
}
// request interceptor
service.interceptors.request.use(
    config => {
      //把参数按abcd排序
      var params ='';
      if(config.method =='post' || (config.studyApi && ['patch','put','delete'].includes(config.method))){
          if (!config.studyApi && !config.preserveText) config.data = replaceNewlineWithBr(config.data)
        params = EUtils.objKeySort(config.data ? config.data : '');
      }else if(config.method =='get'){
        if (!config.studyApi && !config.preserveText) config.params = replaceNewlineWithBr(config.params)
        params = EUtils.objKeySort(config.params ? config.params : '');
      }
      //排序拼接收的数据md5
      var str = params ? crypto.MD5(params).toString() : ''
      //获取时间戳
      var timestamp = Math.floor(new Date().getTime() / 1000);
      // loadingInstance = Loading.service({ fullscreen: true });
      //生成UUID唯一码
      var uuid = EUtils.getCookie('UUID');
      if(!uuid){
        uuid = EUtils.createUuid()
        EUtils.setCookie('UUID',uuid,60*60*60*24*30*30)
      }
      //将参数拼接起来md5获取验证的签名
      var sign = crypto.MD5(timestamp+""+str+"base64:Rtf2e12qlUOTMc/yBQnw1D4x3lAACobYMlu5lHohgP0=").toString()
      config.headers['APP-ID']= '1';
      config.headers['TIMESTAMP']=timestamp;
      config.headers['CLIENT-TYPE']='web';
      config.headers['APP-VERSION']='1.0.0';
      config.headers['CLIENT-MODEL']='web';
      config.headers['UUID']=uuid;
      config.headers['SIGN']=sign;
      if (EUtils.getCookie('Authorization')) {
        config.headers['Authorization'] = EUtils.getCookie('Authorization')
      }
      return config
    },
    error => {
      // loadingInstance.close();
      return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
      const res = response.data
      if (isUnauthorized(response.status, res)) {
        if (!/\/api\/user\/login(?:\?|$)/.test((response.config && response.config.url) || '')) redirectToLogin()
        return Promise.reject(new Error((res && res.message) || '登录已失效，请重新登录'))
      }
      // 已斩题目全部取消后，接口以业务 204 表示合法的空列表。
      if (response.config.emptyListOn204 &&
          (response.status === 204 || Number(res && res.code) === 204)) {
        return { code: 200, data: [] }
      }
      // getMyAnswer 无记录时可能返回 HTTP 204，或 HTTP 200 携带业务 code 204。
      if (response.config.emptyAnswerOn204 &&
          (response.status === 204 || Number(res && res.code) === 204)) {
        return { code: 204, data: null }
      }
      // Study v1 has its own success/error envelope. Keep it out of legacy toasts.
      if (response.config.studyApi) return { body: res, status: response.status }
      // loadingInstance.close();
      // if the custom code is not 20000, it is judged as an error.
      if (res.code !== 200 && !(response.config.acceptNumericCode && Number(res.code) === 200)) {
        // const error={}
        // error.message = res.message || 'Error'
        // error.code = res.code
        // error.data = res.data
        // return Promise.reject(error)
        if(!response.data.code){
          return res
        }else{
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          // if(res.code == 401 || res.code == 406){
          //   Message({
          //     message: res.message || 'Error',
          //     type: 'error',
          //     duration: 5 * 1000
          //   })
          //   window.location.replace('login');
          // }
        }
        return Promise.reject(res.message || '暂无网络')

      } else {
        return res
      }
    },
    error => {
      if (isUnauthorized(error.response && error.response.status, error.response && error.response.data)) {
        if (!/\/api\/user\/login(?:\?|$)/.test((error.config && error.config.url) || '')) redirectToLogin()
        return Promise.reject(error)
      }
      if (error.config && error.config.studyApi) return Promise.reject(error)
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)

      // 网络错误、超时等
      // if (error.response) {
      //   // 服务器返回了响应（如 500、404）
      //   const { status, data } = error.response
      //   const err = {}
      //   err.status = status
      //   err.data = data
      //   return Promise.reject(err)
      // } else if (error.request) {
      //   // 请求已发出，但无响应（如网络断开）
      //   err.code = 'NETWORK_ERROR'
      //   return Promise.reject(err)
      // } else {
      //   // 其他错误
      //   return Promise.reject(error)
      // }
    }
)

export default service
